export default (state={ data: {} }, action) => {
	switch(action.type) {
		// case 'COUNTS_GET_REQUEST':
		// 	return {
		// 		...state,
				
		// 	}
		case 'COUNTS_GET_SUCCESS':
			return {
				data: action.result,
			}
		// case 'COUNTS_GET_ERROR':
		// 	return {
		// 		...state,
		// 		isFetching: false,
		// 		error: action.payload,
		// 	}
		default:
			return state;
	}

}


// WEBPACK FOOTER //
// ./src/modules/counts/counts.reducer.js